<template>
  <div class="media-exit__orderer">
    <v-row>
      <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header
            class="media-exit__expansion_header font-weight-bold"
            ><h2 class="send-file">Send File(s)</h2></v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-expansion-panel-content>
              <v-form ref="form" v-model="valid" lazy-validation>
                <div class="media-exit__orderer__card-content">
                  <v-row class="no-gutters">
                    <v-col cols="12">
                      <div class="media-exit__orderer__send-file">
                        <div class="media-exit__orderer__list from-title">
                          <div class="d-inline-block font-weight-medium mr-4">
                            <p class="from-title-title">From* :</p>
                          </div>
                          <div class="d-inline-block mr-1 p-relative" v-if="!editInput">
                            <label for="from">{{
                              createOrder.email_from
                            }}</label>
                            <div class="loader-overlay" v-if="isoverlay">
                            </div>
                          </div>
                          <div class="d-inline-block" v-if="editInput">
                            <v-text-field
                              v-model="createOrder.email_from"
                              @mouseout="changeField"
                              :rules="emailRulesSingle"
                              required
                              dense
                            ></v-text-field>
                          </div>
                          <div class="d-inline">
                            <span
                              class="ml-2 blue--text cursor-pointer"
                              @click="editInputField"
                              >edit</span
                            >
                          </div>
                        </div>
                        <div class="p-relative">
                            <div v-if="!receiverMail.length"
                            class="send-file-note"
                          >
                            <p class="font-weight-regular">
                              {{ placeholder }}
                            </p>
                          </div>
                          <v-combobox
                            ref="el"
                            :multiple="true"
                            v-model="receiverMail"
                            label="To* "
                            :delimiters="[',', ';']"
                            append-icon
                            chips
                            deletable-chips
                            class="to-emails tag-input mt-n3"
                            :rules="emailRules"
                            required
                            :search-input.sync="emailsearch"
                            @update:search-input="updateReceiverEmails"
                            :hide-no-data="!emailsearch"
                            :items="people"
                            hide-selected
                            @change="clearcache"
                            :menu-props="{ closeOnContentClick: true }"
                            @keydown="handleInput($event)"
                            @focus="handleClickfocus"
                            @blur="handleClickfocus"
                          >
                            <template v-slot:item="data">
                              <template>
                                <v-icon
                                  v-if="!checkUser(data.item)"
                                  aria-hidden="false"
                                  class="mr-2 user-icon"
                                  dark
                                  style="color: #fff"
                                  >mdi-account-group</v-icon
                                >
                                <v-icon
                                  v-if="checkUser(data.item)"
                                  aria-hidden="false"
                                  class="mr-2 user-icon"
                                  dark
                                  style="color: #fff"
                                  >mdi-account</v-icon
                                >
                                <v-list-item-title
                                  style="color: #000"
                                  v-html="data.item"
                                ></v-list-item-title>
                              </template>
                            </template>
                          </v-combobox>
                          <v-img
                            :src="require('../../assets/images/clear.svg')"
                            width="20px"
                            @click="clearToField"
                            height="13px"
                            class="cursor-pointer clear-mail-field"
                          ></v-img>
                        </div>
                        
                        <div
                          class="d-flex
                            checkbox-container
                            media-exit__orderer__checkbox
                          "
                        >
                          <div class="d-inline-block mr-5 media-exit-checkbox">
                            <input
                              type="checkbox"
                              v-model="createOrder.mark_in_cc"
                              class="mr-2"
                              id="markincc"
                            />
                            <label
                              for="markincc"
                              class="checkbox-label font-weight-regular"
                              ><p>Mark me in CC</p></label
                            >
                          </div>
                            <div class="d-flex">
                          <div v-for="(item, index) in groupnameByshortcut.slice(0,3)">
                          <div class="d-inline-block mr-5 media-exit-checkbox">
                            <input
                              type="checkbox"
                              v-model="selectedgroup"
                              :id="item.id"
                              :value="item"
                              :checked="checkboxvalue"
                            />
                            <label
                              :for="item.id"
                              class="checkbox-label font-weight-regular"
                              ><p>{{item.name}} </p></label
                            >
                              </div>
                          </div>
                            </div>
                            <div class="d-inline-block insert-user-dialog ml-2 user-group-popup">
                            <template>
                              <v-row justify="center">
                                <v-dialog
                                v-model="dialogbox"
                                  scrollable
                                  max-width="540px"
                                  elevation="0"
                                  content-class="vdialognew"
                                >
                                    <template v-slot:activator="{ props }">
                                      <div >
                                    <v-btn v-if="groupnameByshortcut.length>3"
                                      class="user-group-more-button"
                                      dark
                                      elevation="0"
                                      :ripple="false"
                                      v-bind="props"
                                      @click="showmorename"
                                      small
                                    >
                                     +{{groupnameByshortcut.length-3}}
                                    </v-btn></div>
                                  </template>
                                  <v-card>
                                    <v-card-title
                                      class="
                                        d-flex
                                        justify-content-space-between
                                      "
                                    >
                                      <span class="title insert-popup-title"
                                        >User Group ({{ groupnameByshortcut.length }})</span
                                      >
                                    </v-card-title>
                                    <v-card-text>
                                      <div  class="insert-user-popup">
                                        <div v-for="(item, index) in groupnameByshortcut">
                                        <div class="d-inline-block mr-5 media-exit-checkbox">
                                          <input
                                            type="checkbox"
                                            v-model="selectedgroup"
                                            :id="item.id"
                                            :value="item"
                                          />
                                          <label
                                            :for="item.id"
                                            class="checkbox-label font-weight-regular"
                                            ><p>{{ item.name }}</p></label
                                          >
                                            </div>
                                        </div>
                                        <!-- <v-data-table
                                          v-model="selectgroupnames"
                                          :headers="headersgroup"
                                          :items="groupnames"
                                          :hide-default-footer="true"
                                          disable-pagination
                                          item-key="name"
                                          select-strategy="single"
                                          class="elevation-0"
                                          fixed-header
                                          height="400"
                                        >
                                          <template
                                            v-slot:[`item.name`]="{ item }"
                                          >
                                            <div v-if="item.shortcut === true"
                                              class="insert-group-truncate"
                                              :title="item.name"
                                            > {{ item.name }}
                                            </div>
                          <div class="d-inline-block mr-5 media-exit-checkbox" v-if="item.shortcut === true">
                            <input
                              type="checkbox"
                              v-model="item.name"
                              :id="item"
                            />
                            <label
                              :for="item"
                              class="checkbox-label font-weight-regular"
                              ><p>{{item.name}}</p></label
                            >
                              </div>
                                          </template>
                                        </v-data-table> -->
                                      </div>
                                    </v-card-text>
                                    <v-card-actions
                                      class="d-flex justify-center"
                                    >
                                      <v-btn
                                        class="btn-solid text-capitalize"
                                        tile
                                        @click="closeUserGroup"
                                        dark
                                        :ripple="false"
                                        elavation="0"
                                        >Close</v-btn
                                      >
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-row>
                            </template>
                          </div>

                          <div class="d-inline-block insert-user-dialog ml-auto">
                            <template>
                              <v-row justify="center">
                                <v-dialog
                                  v-model="dialog"
                                  scrollable
                                  max-width="540px"
                                  elevation="0"
                                  content-class="vdialognew"
                                >
                                  <template v-slot:activator="{ attrs }">
                                    <v-btn
                                      class="insert-user-group"
                                      dark
                                      elevation="0"
                                      :ripple="false"
                                      v-bind="attrs"
                                      @click="insertGroup"
                                      rounded
                                      small
                                    >
                                      Insert User Group
                                    </v-btn>
                                  </template>
                                  <!--if no active user groups availbale-->
                                  <v-card v-if="totalgroups === 0">
                                    <v-card-title
                                      class="
                                        d-flex
                                        justify-content-space-between
                                      "
                                    >
                                      <span class="title insert-popup-title"
                                        >Insert User Group</span
                                      >
                                    </v-card-title>
                                    <v-card-text
                                      style="height: 300px; text-align: center"
                                      class="align-center d-flex justify-center"
                                    >
                                      <div
                                        class="insert-user-popup align-center"
                                      >
                                        No active user group available
                                      </div>
                                    </v-card-text>
                                    <v-card-actions
                                      class="d-flex justify-center"
                                    >
                                      <v-btn
                                        class="btn-solid text-capitalize"
                                        tile
                                        @click="insert"
                                        dark
                                        :ripple="false"
                                        elavation="0"
                                        :class="[
                                          selected.length === 0
                                            ? 'insert-btn-disabled'
                                            : 'insert-btn'
                                        ]"
                                        >Insert</v-btn
                                      >
                                      <v-btn
                                        tile
                                        outlined
                                        @click="closeInsertGroup"
                                        :ripple="false"
                                        border="solid"
                                        height="40"
                                        min-width="108px"
                                        text
                                        elavation="0"
                                        class="
                                          reset-btn reset-order
                                          text-capitalize
                                          black--text
                                          font-weight-bold
                                        "
                                        >Cancel</v-btn
                                      >
                                    </v-card-actions>
                                  </v-card>

                                  <v-card v-else>
                                    <v-card-title
                                      class="
                                        d-flex
                                        justify-content-space-between
                                      "
                                    >
                                      <span class="title insert-popup-title"
                                        >Insert User Group</span
                                      >
                                      <span class="from-title-title"
                                        >{{ selected.length }} of
                                        {{ totalgroups }} groups selected</span
                                      >
                                    </v-card-title>
                                    <v-card-text>
                                      <v-text-field
                                        class="pb-5 pt-2 mt-0 sticky-search"
                                        v-model="search"
                                        label="Search group here"
                                        prepend-inner-icon="mdi-magnify"
                                        single-line
                                        hide-details
                                      ></v-text-field>
                                      <div class="insert-user-popup">
                                        <v-data-table
                                          v-model="selected"
                                          :headers="headers"
                                          :items="groupnames"
                                          :hide-default-footer="true"
                                          disable-pagination
                                          item-key="name"
                                          show-select
                                          class="elevation-0"
                                          :search="search"
                                          fixed-header
                                          height="400"
                                        >
                                          <template
                                            v-slot:[`item.name`]="{ item }"
                                          >
                                            <div
                                              class="insert-group-truncate"
                                              :title="item.name"
                                            >
                                              {{ item.name }}
                                            </div>
                                          </template>
                                        </v-data-table>
                                      </div>
                                    </v-card-text>
                                    <v-card-actions
                                      class="d-flex justify-center"
                                    >
                                      <v-btn
                                        class="btn-solid text-capitalize"
                                        tile
                                        @click="insert"
                                        dark
                                        :ripple="false"
                                        elavation="0"
                                        :class="[
                                          selected.length === 0
                                            ? 'insert-btn-disabled'
                                            : 'insert-btn'
                                        ]"
                                        >Insert</v-btn
                                      >
                                      <v-btn
                                        tile
                                        outlined
                                        @click="closeInsertGroup"
                                        :ripple="false"
                                        border="solid"
                                        height="40"
                                        min-width="108px"
                                        text
                                        elavation="0"
                                        class="
                                          reset-btn reset-order
                                          text-capitalize
                                          black--text
                                          font-weight-bold
                                        "
                                        >Cancel</v-btn
                                      >
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-row>
                            </template>
                          </div>
                        </div>
                        <div
                          class="subject-container media-exit__orderer-subject"
                        >
                          <div class="media-exit__orderer-subject-items">
                            <div
                              class="
                                media-exit__orderer-subject
                                d-inline-block
                                mt-n3
                              "
                            >
                              <v-text-field
                                v-model="createOrder.subject"
                                label="Subject*"
                                :rules="[
                                  subjectRules.required,
                                  subjectRules.counter
                                ]"
                                counter="255"
                                maxlength="255"
                                @update:error="errorCheck"
                              ></v-text-field>
                            </div>
                            <div class="float-right">
                              <div class="d-inline-block mr-5">
                                <div class="send-btn">
                                  <v-btn
                                    class="primary-btn"
                                    tile
                                    @click="placeOrder"
                                    color="indigo"
                                    dark
                                    ><span tile>Send</span></v-btn
                                  >
                                </div>
                              </div>
                              <div class="d-inline-block">
                                <v-btn
                                  tile
                                  color="default"
                                  style="border: 1px solid black"
                                  @click="resetOrder"
                                  class="reset-btn reset-order"
                                  >Reset Order</v-btn
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div class="custom-budget-section budget-section">
                    <v-row>
                      <v-col cols="5" class="search-field-form">
                        <div class="media-exit__orderer__budget mr-5 my-6">
                          <v-select
                            :items="budgetItems"
                            v-model="budgetCodes"
                            label="Budget Code*"
                            item-value="text"
                            :rules="budgetRules"
                            required
                            @input="budgetCodeSelected"
                            id="langSelect"
                          ></v-select>
                          <div
                            class="
                              media-exit__orderer__budget-code
                              mb-5
                              budget-code
                            "
                            v-if="isBudgetcode"
                          >
                            <div class="d-inline pr-1 font-weight-regular">
                              Budget Code:
                            </div>
                            <div class="d-inline" style="color: #3784c4">
                              {{ budgetCodeValue }}
                            </div>
                          </div>
                          <div v-show="isOthersSelected">
                            <v-textarea
                              label="Type Here"
                              v-model="othersMessage"
                              rows="1"
                            ></v-textarea>
                          </div>
                          <div class="radio-buttons">
                            <div class="media-exit__orderer__budget-channel">
                              <v-text-field
                                class="channel-name"
                                v-model="createOrder.channel"
                                :rules="channelRules"
                                label="Channel / Sales Client Name*"
                              ></v-text-field>
                            </div>
                            <div class="media-exit__orderer__budget-channel">
                              <v-text-field
                                class="channel-name"
                                v-model="createOrder.gps_order_id"
                                :rules="GPSRules"
                                label="GPS Order ID"
                              ></v-text-field>
                            </div>
                            <div>
                              <v-select
                                :items="deliveryItems"
                                v-model="deliveryMethods"
                                label="Delivery Method"
                                item-value="text"
                                required
                                @input="deliveryMethodSelected"
                                id="langSelect2"
                              ></v-select>
                            </div>
                            <div
                              class="media-exit__orderer__budget-message mt-n1"
                            >
                              <v-textarea
                                name="input-7-1"
                                label="Message"
                                rows="4"
                                v-model="createOrder.message"
                                class="message-area"
                              ></v-textarea>
                            </div>
                            <div
                              class="media-exit__orderer__budget-date-download"
                            >
                              <div
                                class="
                                  d-flex
                                  media-exit__orderer__budget-date-download-items
                                "
                              >
                                <div
                                  class="
                                    d-flex
                                    p-relative
                                    mr-2
                                    date-picker-expirydate
                                  "
                                >
                                  <v-menu
                                    v-model="dateMenu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        :value="expDate"
                                        label="Expiry Date"
                                        append-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        class="media-exit-cal-input"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="today"
                                      :min="nowDate"
                                      :max="getEndDate"
                                      @input="dateMenu2 = false"
                                      dense
                                      class="media-exit-date-picker"
                                    ></v-date-picker>
                                  </v-menu>
                                </div>
                                <div class="d-inline-block max-download">
                                  <v-select
                                    v-model="createOrder.max_downloads"
                                    :items="maxdownloads"
                                    class="max-downloads"
                                    label="Max Downloads"
                                    required
                                  ></v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <h4
                          class="
                            float-right
                            font-weight-regular
                            mr-1
                            added-file-text
                          "
                          v-if="isOverlayItems || isNorecordOverlay"
                        >
                          {{ s3LiveData.length }} file(s) added
                        </h4>
                        <div class="media-exit__orderer__search-files">
                          <v-card class="mx-auto pl-5 mt-8">
                            <v-toolbar
                              flat
                              color="transparent"
                              class="custom-search-bar-full"
                            >
                              <div class="search-files-overlay">
                                <div class="d-flex">
                                  <div class="d-flex search-btn">
                                    <v-img
                                      :src="
                                        require('../../assets/images/search.svg')
                                      "
                                      width="18px"
                                      height="18px"
                                      class="custom-search-icon"
                                    ></v-img>
                                    <v-text-field
                                      v-model="fileSearch"
                                      :disabled="isInputFiledDisabled"
                                      single-line
                                      @keypress.enter="getSearchFiles"
                                    >
                                    </v-text-field>

                                    <div
                                      class="
                                        search-btn-container
                                        cursor-pointer
                                      "
                                    >
                                      <v-img
                                        @click="clearSeachField"
                                        :src="
                                          require('../../assets/images/clear.svg')
                                        "
                                        width="20px"
                                        height="13px"
                                        class="cursor-pointer"
                                      ></v-img>
                                      <div class="search-btn">
                                        <v-btn
                                          :disabled="fileSearch ? disabled : ''"
                                          @click="getSearchFiles"
                                          depressed
                                          :ripple="false"
                                          class="font-weight-thin pa-0 ml-3"
                                          ><span class="pa-0 ml-3" tile dark
                                            >SEARCH</span
                                          ></v-btn
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-toolbar>

                            <!--FILE SECTION STARTS HERE-->
                            <!---------------------------->
                            <span v-if="isFilesAdded"
                              ><p
                                style="
                                  margin-top: -24px;
                                  font-size: 12px;
                                  color: red;
                                  padding-bottom: 2px;
                                "
                              >
                                {{ isfiles }}
                              </p></span
                            >
                            <v-list
                              three-line
                              class="mt-n5"
                              v-if="isOverlayItems"
                            >
                              <div class="close-overlay load-more-text">
                                <div
                                  v-if="
                                    !searchOverlayPaginate &&
                                      fileSearchItems.length === 0
                                  "
                                >
                                  No Records Found
                                </div>
                                <div
                                  v-if="
                                    searchOverlayPaginate &&
                                      fileSearchItems.length === 0
                                  "
                                >
                                  <a href="javascript:void(0)"
                                    ><span
                                      @click="getSearchFiles"
                                      class="
                                        cursor-pointer
                                        text-center
                                        added-file-text
                                        font-weight-regular
                                      "
                                      >Load More Records ({{
                                        totalSearchCount - searchPageSize
                                      }})</span
                                    ></a
                                  >
                                </div>
                                <button
                                  class="close-file-section load-more-close"
                                  @click="showCartfiles"
                                >
                                  <img
                                    src="../../assets/images/close.svg"
                                    alt="close"
                                    width="18"
                                    height="18"
                                  />
                                </button>
                              </div>

                              <div
                                class="file-list-items file-list-scroll"
                                :class="{
                                  scrollSpace: fileSearchItems.length > 5,
                                  'mt-6': fileSearchItems.length
                                }"
                              >
                                <div
                                  class="d-flex file-list"
                                  v-for="(item, index) in fileSearchItems"
                                  :key="index"
                                >
                                  <div class="file-icon">
                                    <img
                                      src="../../assets/images/file.svg"
                                      alt="file"
                                      max-width="44"
                                      min-width="44"
                                    />
                                  </div>
                                  <div class="file-list-desc-section">
                                    <p class="file-list-name">
                                      {{ item.file_name }}
                                    </p>
                                    <p class="file-list-desc">
                                      {{ item.bucket_name }} /
                                      {{ item.file_path }}
                                    </p>
                                  </div>
                                  <div
                                    class="cursor-pointer ml-auto"
                                    @click="addFilesToCart(item, index)"
                                  >
                                    <img
                                      src="../../assets/images/add_file.svg"
                                      alt="file"
                                      width="30"
                                      height="30"
                                    />
                                  </div>
                                </div>
                              </div>
                            </v-list>
                            <!--FILE SECTION END HERE-->

                            <v-list
                              three-line
                              class="mt-n5"
                              v-else-if="isNorecordOverlay"
                            >
                              <div class="close-overlay-no-record overflow">
                                <div class="no-record-decs">
                                  {{ isSearchDataNotAvailble }}
                                </div>
                                <button
                                  class="close-btn"
                                  @click="clearNorecodFiles"
                                >
                                  <img
                                    src="../../assets/images/close.svg"
                                    alt="close"
                                    width="18"
                                    height="18"
                                  />
                                </button>
                              </div>
                            </v-list>
                            <!-- Added files to cart -->
                            <div v-if="isFilesInCart && s3LiveData.length">
                              <div
                                class="
                                  d-flex
                                  justify-content-space-between
                                  count-remeove-all-section
                                "
                              >
                                <div class="d-inline-block">
                                  <p class="mb-0 file-added-count">
                                    ({{ s3LiveData.length }} files added)
                                  </p>
                                </div>
                                <div class="d-inline-block remove-all">
                                  <span
                                    class="app-light-blue--text cursor-pointer"
                                    v-if="s3LiveData.length !== 0"
                                    @click="removeAll"
                                    >Remove All</span
                                  >
                                </div>
                              </div>
                              <div
                                class="file-list-items file-list-scroll"
                                :class="
                                  s3LiveData.length > 5 ? 'scrollSpace' : ''
                                "
                              >
                                <div
                                  class="d-flex file-list"
                                  v-for="(item, index) in s3LiveData"
                                  :key="index"
                                >
                                  <div class="file-icon">
                                    <img
                                      src="../../assets/images/file.svg"
                                      alt="file"
                                      max-width="44"
                                      min-width="44"
                                    />
                                  </div>
                                  <div class="file-list-desc-section">
                                    <p class="file-list-name">
                                      {{ item.file_name }}
                                    </p>
                                    <p class="file-list-desc-modified mb-0">
                                      Modified:
                                      {{
                                        moment(item.last_modified).format(
                                          "DD MMM YYYY, h:mm A"
                                        )
                                      }}
                                      | {{ item.file_size | fileSizeConverter }}
                                    </p>
                                    <p
                                      class="file-list-desc"
                                      :title="
                                        item.bucket_name + '/' + item.file_path
                                      "
                                    >
                                      {{ item.bucket_name }}/
                                      {{ item.file_path }}
                                    </p>
                                  </div>
                                  <div class="ml-auto">
                                    <div
                                      class="status-label-small"
                                      :style="{
                                        'background-color':
                                          item.storage_status === 'Archived'
                                            ? '#E89D42'
                                            : '#81B533'
                                      }"
                                    >
                                      {{
                                        item.storage_status === "Active"
                                          ? "Available"
                                          : item.storage_status
                                      }}
                                    </div>
                                    <div
                                      class="
                                        cursor-pointer
                                        d-inline-block
                                        float-right
                                        mt-3
                                      "
                                      id="ck"
                                      @click="removeFilesFromCart(index)"
                                    >
                                      <img
                                        src="../../assets/images/remove_file.svg"
                                        alt="file"
                                        width="30"
                                        height="30"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </div>
</template>

<script>
import Crypto from "../../encrypt";
import moment from "moment";
import { format, parseISO } from "date-fns";
const _from_email = process.env.VUE_APP_from_address;
export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    panel: [0, 1],
    btnColor: "pink",
    isoverlay: false,
    valid: true,
    budgetCodes: "",
    deliveryMethods: "",
    dialog: false,
    dialogbox: false,
    disabled: false,
    disabledTo: true,
    readonly: false,
    isBudgetcode: false,
    counterFiles: 0,
    fileSearch: null,
    isfiles: "No Files Added",
    isInputFiledDisabled: false,
    filesSeleted: 0,
    isOverlayItems: false,
    isNorecordOverlay: false,
    userName: "",
    from_address: _from_email,
    budgetCodeValue: null,
    today: format(parseISO(moment(new Date()).add(30, "days").toISOString()),"yyyy-MM-dd"),
    date: new Date(),
    nowDate: format(parseISO(moment(new Date()).toISOString()), "yyyy-MM-dd"),
    others: "",
    othersMessage: "",
    isOthersSelected: false,
    menu2: false,
    isSearchDataNotAvailble: null,
    addIcon: {
      icon: require("../../assets/images/add_file.svg")
    },
    notifications: [
      { id: 1, title: "Settings" },
      { id: 2, title: "Sign Out" }
    ],
    // handling budget code
    budgetItems: [
      { text: "A+E International Pays (505100)" },
      { text: "Client Pays (505101)" },
      { text: "Other" }
    ],
    deliveryItems: [
      { text: "Aspera Faspex" },
      { text: "Aspera P2P" },
      { text: "Signiant" }
    ],
    s3fileIds: [],
    budgetCode: "",
    editInput: false,
    downloads: [],
    maxdownloads: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"],
    search: undefined,
    select: undefined,
    markinCC: undefined,
    includeGlobalList: true,
    receiverMail: [],
    selectgroupnames: [],
    emailsearch: "",
    emptyFiles: "",
    // to get file names based on search
    fileName: {
      file_name: ""
    },
    emailFrom: "",
    addedCartFiles: [],
    isFilesInCart: false,
    isFilesAdded: false,
    dateMenu2: false,
    searchOverlayPaginate: false,
    totalSearchCount: 0,
    searchPageSize: 50,
    // handling send files
    createOrder: {
      email_from: "",
      mark_in_cc: false,
      global_cc_mail: _from_email,
      subject: "",
      message: "",
      expiry_date: null,
      max_downloads: "02",
      budget_code: "",
      channel: "",
      gps_order_id: "",
      delivery_method: "",
      receivers: [],
      ordered_items: [],
      other_code: "",
      groupnameByshortcut:[]
    },
    searchRules: [v => !!v || "No Files added"],
    emailRulesSingle: [
      v => !!v || "E-mail is required",
      v => new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ).test(v) || "E-mail must be valid"
    ],
    emailRules: [
      v => {
        if (!v || v.length < 1) return "Email or User group is required";
        else if (v.length > 0) {
          let invalidEmails = [];
          for (let i = 0; i < v.length; i++) {
            let email = v[i];
            if (
              !new RegExp(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              ).test(email) && !new RegExp(
                /^([^<>()\[\]\\.,;:\s@"]|(\.[^<>()\[\]\\.,;:\s@"]+)*)|([a-zA-Z0-9])|([a-zA-Z0-9])$/
              ).test(email)
            ) {
              invalidEmails.push(email);
            }
          }
          if (invalidEmails.length) {
            return `Invalid email(s) - ${invalidEmails.join(",")}`;
          }
          return v;
        } else return v;
      }
    ],
    GPSRules: [
      v => {
        if (v.length > 0) {
          let invalidGPS = "";
          let gpsid = v;
          if (!new RegExp(/^([0-9]){4}$/).test(gpsid)) {
            return "GPS ID should be of 4 digits";
          }
          if (invalidGPS.length) {
            return `Invalid GPS ID - ${invalidGPS.join(",")}`;
          }
        }
      }
    ],
    totalgroups: Number,
    singleSelect: false,
    selected: [],
    selectedgroup: [],
    checkboxvalue:Boolean,
    placeholder: 'You can add multiple recipients',
    dasaff:[{}],
    headers: [
      {
        text: "Select All",
        align: "start",
        sortable: false,
        value: "name"
      }
    ],
    headersgroup: [
      {
        align: "start",
        sortable: false,
        value: "name"
      }
    ],
    groupnames: [],
    groupstoAdd: [],
    groupnameByshortcut:[],
    duplicatesMail: [],
    uniqueGroup: [],
    subjectRules: {
      required: v => !!v || "Subject is required",
      counter: v => !!v && v.length <= 255 || "Max 255 characters"
    },
    budgetRules: [v => !!v || "Budget Code is required"],
    channelRules: [v => !!v || "Channel / Sales Client Name is required"],
    s3LiveData: [],
    fileSearchItems: null,
    results: "",
    isUpdating: false,
    name: "Midnight Crew",
    message: "",
    people: [],
    editing: null,
    editingIndex: -1,
    items: [],
    menu: false,
    x: 0,
    y: 0
  }),
  computed: {
    expDate() {
      return this.today ? moment(this.today).format("DD MMM YYYY") : "";
    },
    getEndDate() {
      var endDate = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        30 + this.date.getDate()
      );
      return endDate.toISOString().slice(0, 10);
    }
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    }
  },
  methods: {
    handleClickfocus(){
      this.placeholder = ''
    },
    showmorename(){
      this.dialogbox = true;
      
    },
    checkUser(ele) {
      if (ele.includes("@") && !this.groupstoAdd.includes(ele)) {
        return true;
      } else if (!ele.includes("@") && this.groupstoAdd.includes(ele)) {
        return false;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.groupnames.slice();
    },
    errorCheck(isError) {
      if (isError) {
        console.log("error!");
      }
    },
    clearcache() {
      this.people = [];
      this.emailsearch = "";
    },
    handleInput(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        this.people = [];
      }
    },
    // for auto serach
    decode(str) {
      return str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
    },
    test(e) {
      e.preventDefault();
    },
    remove(item) {
      const index = this.receiverMail.indexOf(item);
      if (index >= 0) this.receiverMail.splice(index, 1);
    },
    updateReceiverEmails(e1) {
      /*------------------------To discard user groups which are not there and to validate new email----------------------*/
      let validateemail = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      let invalidEmail = [];
      if (this.receiverMail.length < 1 && invalidEmail.length < 1) {
        this.emailRules = [];
        this.emailRules.push("Email or User group is required");
      }

      this.receiverMail.forEach((x, i) => {
        this.emailRules = [];
        if (this.groupstoAdd.includes(x)) {
          console.log(this.groupstoAdd,'this')
          this.receiverMail[i] = x;
          if (invalidEmail.length) {
            this.emailRules.push(
              `Invalid email(s) or group(s) - ${invalidEmail.join(", ")}`
            );
          }
        } else if (
          !this.groupstoAdd.includes(x) &&
          validateemail.test(this.receiverMail[i])
        ) {
          this.receiverMail[i] = x;
          if (invalidEmail.length) {
            this.emailRules.push(
              `Invalid email(s) or group(s) - ${invalidEmail.join(", ")}`
            );
          }
        } else if (!validateemail.test(x) && !this.groupstoAdd.includes(x)) {
          invalidEmail.push(x);
          if (invalidEmail.length) {
            this.emailRules.push(
              `Invalid email(s) or group(s) - ${invalidEmail.join(", ")}`
            );
          }
        }
      });

      /*------------------for remvoing duplicates when pasted mutiple emails-----------------------*/
      if (this.emailsearch && this.emailsearch.split(";").length > 1) {
        this.receiverMail = this.receiverMail.concat(
          this.emailsearch
            .split(";")
            .filter(term => !this.receiverMail.includes(term.trim()))
        );
        this.receiverMail.forEach((x, i) => {
          this.receiverMail[i] = x.trim();
        });
        this.emailsearch = "";
      }
      /*---------------------------for Autosuggest API call--------------------------------*/
      if (this.emailsearch.length >= 3) {
        const vm = this;
        const domainUrl = "api/autosuggest/";
        let queryParam = { name: this.emailsearch };
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, queryParam)
          .then(data => {
            this.people = data.data.receivers;
          });
      } else if (this.emailsearch.length === "") {
        this.people = [];
        this.emailsearch = "";
      } else {
        this.people = [];
        this.$refs.el.lazySearch = "";
      }
      this.$refs.el.lazySearch = "";
    },
    clearToField() {
      this.receiverMail = [];
      this.emailRules = [];
      this.people = [];
    },
    changeField() {
      let emailValidationRegExp = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if (!emailValidationRegExp.test(this.createOrder.email_from)) {
        this.editInput = true;
      } else {
        this.editInput = false;
      }
    },
    updateTags() {
      this.$nextTick(() => {
        this.select.push(...this.search.split(","));
        this.$nextTick(() => {
          this.search = "";
        });
      });
    },
    resetOrder() {
      this.$swal({
        icon: "warning",
        title: "Are you sure you want to reset the order?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.receiverMail = [];
          this.includeGlobalList = true;
          this.createOrder.mark_in_cc = false;
          this.createOrder.subject = "";
          this.createOrder.message = "";
          this.createOrder.channel = "";
          this.createOrder.gps_order_id = "";
          this.fileSearchItems = [];
          this.isFilesInCart = false;
          this.$refs.form.resetValidation();
          this.isFilesAdded = false;
          this.fileSearch = "";
          this.selectedgroup = []
          this.today = format(
            parseISO(
              moment(new Date())
                .add(30, "days")
                .toISOString()
            ),
            "yyyy-MM-dd"
          );
          this.createOrder.email_from = this.emailFrom;
          this.isFilesAdded = false;
          this.counterFiles = 0;
          this.budgetCodes = "";
          this.deliveryMethods = "";
          this.isNorecordOverlay = false;
          this.othersMessage = "";
          this.isOthersSelected = false;
          this.budgetCodeValue = "";
          this.s3LiveData = [];
          this.isOverlayItems = false;
          this.createOrder.budget_code = "A+E International Pays (505100)";
          this.createOrder.max_downloads = "02";
          this.createOrder.receivers = [];
          this.createOrder.other_code = "";
        }
      });
    },
    getSearchFiles() {
      this.isFilesAdded = false;
      this.isFilesInCart = false;
      const vm = this;
      const domainUrl = "api/s3filesearch/";
      this.s3fileIds = [];
      this.s3LiveData.forEach((ele, index) => {
        this.s3fileIds.push(ele.s3_file_id);
      });
      let queryParam = { search: this.fileSearch, id: this.s3fileIds };
      if (vm.$apiService) {
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, queryParam)
          .then(data => {
            this.results = data.data.results.length;
            this.totalSearchCount = data.data.count;
            this.searchOverlayPaginate =
              data["data"].count > this.searchPageSize ? true : false;
            this.isSearchDataNotAvailble = null;
            this.isNorecordOverlay = false;
            this.isOverlayItems = true;
            if (data.data.results.length === 0) {
              this.isOverlayItems = false;
              this.isNorecordOverlay = true;
              this.isSearchDataNotAvailble = "No Records Found";
              this.isFilesAdded = false;
            }
            this.fileSearchItems = data.data.results;
          });
      }
    },
    removeAll() {
      this.isFilesAdded = true;
      this.s3LiveData = [];
      this.isInputFiledDisabled = false;
      this.isOverlayItems = false;
      this.counterFiles = 0;
      this.isNorecordOverlay = false;
      this.isFilesInCart = false;
    },
    clearSeachField() {
      this.fileSearch = "";
      if (this.s3LiveData.length === 0 && this.fileSearch === "") {
        this.isFilesAdded = false;
      } else if (this.s3LiveData.length >= 1) {
        this.isFilesAdded = false;
        this.searchRules = [];
      }
    },
    //  get input filed
    editInputField() {
      this.editInput = true;
    },
    // clear files
    showCartfiles() {
      this.isInputFiledDisabled = false;
      this.isFilesInCart = true;
      if (this.s3LiveData.length === 0) {
        this.isFilesAdded = true;
      }
      this.isOverlayItems = false;
    },
    clearNorecodFiles() {
      this.isInputFiledDisabled = false;
      this.fileSearch = "";
      this.isFilesInCart = true;
      this.isOverlayItems = false;
      this.isNorecordOverlay = false;
    },
    // add selected files to cart
    addFilesToCart(item, index) {
      this.isFilesAdded = false;
      this.counterFiles++;
      this.fileSearchItems.splice(index, 1);
      let queryParam = item.s3_file_id;
      const domainUrl = "api/s3livedata/" + queryParam;
      let vm = this;
      if (vm.$apiService) {
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, queryParam)
          .then(data => {
            let s3data = data.data;
            this.s3LiveData.push(s3data);
            if (s3data.storage_status === "Active") {
              this.btnColor = "#81B533";
            } else if (
              s3data.storage_status === "Cancalled" ||
              s3data.storage_status === "Archived" ||
              s3data.storage_status === "Expired" ||
              s3data.storage_status === "Max Limit Reached"
            ) {
              this.btnColor = "#CC485E";
            }
          });
      }
    },
    removeFilesFromCart(index) {
      this.s3LiveData.splice(index, 1);
      this.counterFiles--;
      if (this.s3LiveData.length === 0) {
        this.isFilesAdded = true;
      }
    },
    placeOrder() {
      if (this.includeGlobalList === true) {
        this.createOrder.global_cc_mail = this.from_address;
      } else if (this.includeGlobalList === false) {
        this.createOrder.global_cc_mail = "";
      }
      if (this.budgetCodes === "Other" && this.othersMessage !== "") {
        // this is for future refference--> this.createOrder.budget_code = "Other " + "& " + this.othersMessage;
        this.createOrder.budget_code = "Other";
        this.createOrder.other_code = this.othersMessage;
      } else if (this.budgetCodes === "Other" && this.othersMessage === "") {
        this.createOrder.budget_code = "Other";
        this.createOrder.other_code = "";
      }

      if (this.s3LiveData.length < 1) {
        this.isFilesAdded = true;
        this.searchRules = [];
      } else if (this.s3LiveData.length > 1) {
        this.isFilesAdded = false;
      }
      
      // form validation
      this.placeOrderFormValidation();
    },
    placeOrderFormValidation() {
      this.$refs.form.validate();
      this.isoverlay = true;
      let expirydatedefault = moment(this.today).format("YYYY-MM-DD");
      this.createOrder.expiry_date = expirydatedefault;
      this.createOrder.receivers = [];
      this.createOrder.ordered_items = [];
      // this.receiverMail.forEach((ele, index) => {
      //   this.createOrder.receivers.push({ receiver_mail: ele });
      // });
      this.selectedgroup.forEach((ele) => {
        this.createOrder.receivers.push({ receiver_mail: ele.name });
      });
      this.receiverMail.forEach((ele, index) => {
        let reqObj = { receiver_mail: ele }
        this.createOrder.receivers.push(reqObj);
      });
      this.s3LiveData.forEach((e, index) => {
        this.createOrder.ordered_items.push({
          s3file: Crypto.set(e.s3_file_id),
          file_status: e.storage_status
          /*-- old code --
          s3file: e.s3_file_id,
          file_status: e.storage_status--*/
        });
      });

      if (this.$refs.form.validate() && this.s3LiveData.length >= 1) {
        const vm = this;
        const plceOrderUrl = "api/order/";
        //vm.createOrder.email_from = this.emailFrom;
        vm.createOrder.email_from = Crypto.set(this.emailFrom);
        console.log("vm.createOrder",vm.createOrder)
        vm.$apiService
          .getData("post", `${plceOrderUrl}`, {}, this.createOrder, null, {})
          .then(data => {
            if (data.data.status) {
              this.receiverMail.forEach((ele, index) => {
                this.createOrder.receivers = [];
              });
              this.isoverlay = false;
              vm.createOrder.email_from = this.emailFrom;
              this.$swal({
                icon: "success",
                confirmButtonText: "Ok",
                showCloseButton: true,
                text: data.data.message
              }).then(result => {
                if (result.isConfirmed === true) {
                  this.isoverlay = false;
                  this.receiverMail = [];
                  this.createOrder.subject = "";
                  this.createOrder.message = "";
                  this.createOrder.channel = "";
                  this.createOrder.gps_order_id = "";
                  this.createOrder.delivery_method = "";
                  this.includeGlobalList = true;
                  this.fileSearchItems = [];
                  this.createOrder.mark_in_cc = false;
                  this.isFilesInCart = false;
                  this.$refs.form.resetValidation();
                  this.isFilesAdded = false;
                  this.fileSearch = "";
                  this.today = format(
                    parseISO(
                      moment(new Date())
                        .add(30, "days")
                        .toISOString()
                    ),
                    "yyyy-MM-dd"
                  );
                  this.createOrder.email_from = this.emailFrom;
                  this.isFilesAdded = false;
                  this.counterFiles = 0;
                  this.budgetCodes = "";
                  this.deliveryMethods = "";
                  this.isNorecordOverlay = false;
                  this.othersMessage = "";
                  this.isOthersSelected = false;
                  this.budgetCodeValue = "";
                  this.s3LiveData = [];
                  this.isOverlayItems = false;
                  this.createOrder.budget_code =
                    "A+E International Pays (505100)";
                  this.createOrder.max_downloads = "02";
                  this.createOrder.receivers = [];
                }
              });
            } else {
              this.$swal({
                icon: "warning",
                confirmButtonText: "Ok",
                showCloseButton: true,
                text: data.data
              }).then(result => {
                //-- to console. error cosole.log(data.data.error);
              });
            }
          });
      }
    },
    //insert user group function
    insertGroup() {
      this.dialog = true;
      let queryParam = { name: "", status: true };
      const domainUrl = "api/usergroup/";
      let vm = this;
      if (vm.$apiService) {
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, queryParam)
          .then(data => {
            if (data) {
              this.totalgroups = data.data.length;
              this.groupnames = data.data;
            }
          });
      }
    },
    //to insert group into To feild
    insert() {
      this.selected.forEach(ele => {
        if (this.receiverMail.includes(ele.name)) {
          this.receiverMail.includes(ele.name.trim());
        } else {
          this.receiverMail.push(ele.name);
        }
        this.people = this.receiverMail;
      });
      this.dialog = false;
      this.selected = [];
      this.search = "";
    },
    checkedusergroup(){
      this.selected.forEach(ele => {
          this.groupppl.push(ele.name);
        this.people = this.groupppl;
      });
      this.dialog = false;
      this.selected = [];
      this.search = "";
    },
    // to close insert group popup function
    closeInsertGroup() {
      this.dialog = false;
      this.selected = [];
      this.search = "";
    },
    closeUserGroup(){
      this.dialogbox = false;
    },
    // get budget code values
    budgetCodeSelected() {
      if (this.budgetCodes === "A+E International Pays (505100)") {
        this.budgetCodeValue = "1000-100050000-444000500-PP-505100";
        this.createOrder.budget_code =
          "A+E International Pays & 1000-100050000-444000500-PP-505100";
        this.isOthersSelected = false;
        this.isBudgetcode = true;
      } else if (this.budgetCodes === "Client Pays (505101)") {
        this.budgetCodeValue = "1000-100050000-444000500-505101";
        this.createOrder.budget_code =
          "Client Pays & 1000-100050000-444000500-505101";
        this.isOthersSelected = false;
        this.isBudgetcode = true;
      } else if (this.budgetCodes === "Other") {
        this.budgetCodeValue = "";
        this.isBudgetcode = false;
        this.isOthersSelected = true;
      }
    },
    deliveryMethodSelected() {
      if (this.deliveryMethods === "Aspera Faspex") {
        this.createOrder.delivery_method = "Aspera Faspex";
      } else if (this.deliveryMethods === "Aspera P2P") {
        this.createOrder.delivery_method = "Aspera P2P";
      } else if (this.deliveryMethods === "Signiant") {
        this.createOrder.delivery_method = "Signiant";
      }
    }
  },
  created() {
    let queryParam = { name: "", status: true };
    const groupdataUrl = "api/usergroup/";
    let vm = this;
    if (vm.$apiService) {
      vm.$apiService
        .getData("get", `${groupdataUrl}`, {}, {}, null, queryParam)
        .then(data => {
          if (data) {
            this.totalgroups = data.data.length;
            this.groupnames = data.data;
          }
          this.groupnames.forEach(ele => {
            this.groupstoAdd.push(ele.name);
            if(ele.shortcut === true){
              this.groupnameByshortcut.push(ele)
            }
          });
        });
    }
  },
  mounted() {
    const vm = this;
    const domainUrl = "api/userdata/";
    if (vm.$apiService) {
      vm.$apiService
        .getData("get", `${domainUrl}`, {}, {}, null, {})
        .then(data => {
          if (data.data) {
            this.userName = data.data.first_name;
            this.createOrder.email_from = data.data.email;
            this.emailFrom = data.data.email;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "OrdererSendFile";
</style>

<style lang="scss">
@import "OrdererSendFile_unscoped.scss";
</style>
